import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/main-logo.svg'
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import toast from 'react-hot-toast';
import Button from '../../components/ui/Button';
import SignUpValidation from '../../validations/auth/SignUpValidation';
import ResetPasswordValidation from '../../validations/auth/ResetPasswordValidation';
import { Routes } from '../../constants/RouteConstants';
import CustomInput from '../../components/ui/CustomInput';
import viewOn from '../../assets/images/view-on-icon.svg'
import viewOff from '../../assets/images/view-off-icon.svg'

interface FormInputs {
  email: string;
  password: string;
  confirm_password: string;
  otp: string;
};

const ResetPassword = () => {

  const { state } = useLocation();
  const navigate = useNavigate();
  const resetPassword = useMakeRequest();
  const [showPwd, setShowPwd] = useState(false)
  const [showCnfPwd, setShowCnfPwd] = useState(false)
  const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    resolver: yupResolver(ResetPasswordValidation),
    defaultValues: {
      email: state?.email,
      otp: state?.otp
    }
  });

  const onSubmit = async (payload: FormInputs) => {
    const requestData = { ...payload, verify_type: "RESET_PASSWORD" }

    toast.promise(
      resetPassword.makeRequest({ payload: requestData, url: ApiConstants?.ResetPassword }),
      {
        loading: 'Processing...',
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    );
  }

  useEffect(() => {

    if (!state?.email && !state?.otp) {
      navigate(Routes?.Login)
    }
    if (resetPassword?.status) {
      navigate(Routes?.Login)
    }
  }, [resetPassword?.status])
  return (
    <main id="main-content" className="auth-page signup-page">
      <h1 className='auth-title'>Reset Password</h1>
      <p className='auth-sub-para'>Set a new password for your account.</p>
      <form onSubmit={handleSubmit(onSubmit)} className='auth-form-wrap'>
        <div className="auth-form-fields">
          <CustomInput
            label="Password"
            type={showPwd ? 'text' : 'password'}
            placeholder="**********"
            required
            {...register('password')}
            error={errors.password?.message}
            icon={
              showPwd ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
            }
            onIconClick={() => setShowPwd(!showPwd)}
          />
          {/* <div className="mb-3 com-input-grp">
          <label className="form-label">Password<span className='label-star'>*</span></label>
          <div className='position-relative paas-eye-field'>
            <input
              type={showPwd ? 'text' : 'password'}
              className="form-control"
              placeholder='Enter password'
              {...register('password')}
            />
            <i className={`pass-eye ${showPwd ? "icon-eye" : "icon-eye-close"}`} onClick={() => setShowPwd(!showPwd)}></i>
          </div>
          <ErrorMessage
            errors={errors}
            name="password"
            render={({ message }) => <p className='valid-error'>{message}</p>}
          />
        </div> */}

          {/* <div className="mb-3 com-input-grp">
            <label className="form-label">Confirm Password<span className='label-star'>*</span></label>
            <div className='position-relative paas-eye-field'>
              <input
                type={showCnfPwd ? 'text' : 'password'}
                className="form-control"
                placeholder='Re-enter password'
                {...register('confirm_password')}
              />
              <i className={`pass-eye ${showCnfPwd ? "icon-eye" : "icon-eye-close"}`} onClick={() => setShowCnfPwd(!showCnfPwd)}></i>
            </div>
            <ErrorMessage
              errors={errors}
              name="confirm_password"
              render={({ message }) => <p className='valid-error'>{message}</p>}
            />
          </div> */}

          <CustomInput
            label="Confirm Password"
            type={showCnfPwd ? 'text' : 'password'}
            placeholder="**********"
            required
            {...register('confirm_password')}
            error={errors.confirm_password?.message}
            icon={
              showCnfPwd ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
            }
            onIconClick={() => setShowCnfPwd(!showCnfPwd)}
          />
        </div>
        <Button className='com-btn my-5' type='submit' loading={resetPassword?.loading}>Reset Password</Button>
      </form>
    </main>
  )
}

export default ResetPassword